module.exports = __webpack_public_path__ + "static/media/tips2-2-found.65702369.png";